import withNewUserWizardFrame from "./withNewUserWizardFrame";

export default { withNewUserWizardFrame };
